export const services = [ // List of available states and their corresponding services
    {
        id: 1,
        name: "services.services[0].name", //Virtus Immigration
        description:"services.services[0].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/inmigration.svg'), // Image path for the service
        content: "services.services[0].content",
        availability: "services.services[0].availability"        
    },
            {
        id: 10,
        name: "services.services[9].name", //Interpretation and Translation Services
        description:"services.services[9].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/translation&interpretation.svg'),
        content: "services.services[9].content",
        availability: "services.services[9].availability" 
    },
    {
        id: 6,
        name: "services.services[6].name", //Accounting and Taxes Virtus
        description:"services.services[6].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/taxes.svg'), // Image path for the service
        content: "services.services[6].content",
        availability: "services.services[6].availability" 
    },
    {
        id: 5,
        name: "services.services[5].name", //Virtus Insurance
        description:"services.services[5].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/insurance.svg'),
        content: "services.services[5].content",
        availability: "services.services[5].availability" 
    },
    {
        id: 7,
        name: "services.services[7].name", //Life Coach Virtus
        description:"services.services[7].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/coach.svg'),
        content: "services.services[7].content",
        availability: "services.services[7].availability" 
    },
    {
        id: 2,
        name: "services.services[2].name", //Your Home Virtus
        description:"services.services[2].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/home.svg'),
        content: "services.services[2].content",
        availability: "services.services[2].availability" 
    },
    {
        id: 3,
        name: "services.services[3].name", //Your Home Credit Virtus
        description:"services.services[3].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/home-credit.svg'),
        content: "services.services[3].content",
        availability: "services.services[3].availability" 
    },
    {
        id: 4,
        name: "services.services[4].name", //Your Car Virtus
        description:"services.services[4].description",
        path: "https://www.uscis.gov/green-card/family-green-cards",
        image: require('../assets/services/car.svg'),
        content: "services.services[4].content",
        availability: "services.services[4].availability" 
    },

]

export const availableStates = [ // List of services
    { id: 0, name: "services.servicesSelector.availableStates.allServices", availableServices: [1, 2, 3, 4, 5, 6, 7, 10] },
    { id: 1, name: "services.servicesSelector.availableStates.americanTerritory", availableServices: [1, 10, 7] },
    { id: 2, name: "services.servicesSelector.availableStates.worlwide", availableServices: [7] },
    { id: 3, name: "services.servicesSelector.availableStates.arizona", availableServices: [1, 6, 7, 10] },
    { id: 4, name: "services.servicesSelector.availableStates.california", availableServices: [1, 3, 6, 7, 10] },
    { id: 5, name: "services.servicesSelector.availableStates.colorado", availableServices: [1, 6, 7, 10] },
    { id: 6, name: "services.servicesSelector.availableStates.florida", availableServices: [1, 2, 3, 4, 6, 7, 10] },
    { id: 7, name: "services.servicesSelector.availableStates.idaho", availableServices: [1, 6, 7, 10] },
    { id: 8, name: "services.servicesSelector.availableStates.utah", availableServices: [1, 4, 5, 6, 7, 10] },
    { id: 9, name: "services.servicesSelector.availableStates.texas", availableServices: [1, 3, 6, 7, 10] },
]